import Chance from 'chance';

import walkNodes from './walkNodes';

function setCustomStatePayload(payload, caseConf) {
  payload.customStates = [];
  walkNodes(payload, ['CUSTOM_STATE'], (nodeData) => {
    const alreadyInPayload = payload.customStates.find(s => s.id === nodeData.id);
    const customState = caseConf.caseLogicDescription.customStates.find(s => s.id === nodeData.id);
    if (!alreadyInPayload && customState) {
      payload.customStates.push(customState);
    }
  });
}

async function pasteCustomStates(caseConf, payload) {
  if (payload.customStates.length > 0) {
    const stateMap = await appendCustomStates(caseConf, payload.customStates);
    walkNodes(payload, ['CUSTOM_STATE'], (nodeData) => {
      nodeData.id = stateMap[nodeData.id];
    });
  }
}

async function appendCustomStates(caseConf, customStates) {
  const chance = new Chance();
  const stateMap = {}; // { oldId: newId}
  
  for (const custom of customStates) {
    const existing = caseConf.caseLogicDescription.customStates.find(
      s => s.label === custom.label
    )
    if (existing) {
      stateMap[custom.id] = existing.id;
    } else {
      const newCustomState = {
        id: chance.guid(),
        label: custom.label,
        value: custom.value,
      }
      stateMap[custom.id] = newCustomState.id;
      caseConf.caseLogicDescription.customStates.push(newCustomState);
    }
  }

  return stateMap;
}

export {
  setCustomStatePayload,
  pasteCustomStates,
};
